// @flow
import React, { Component } from 'react';
import { WarningSVG, WarningTextH5, ErrorMessageDiv } from './EmptyTableStyles';

type Props = {
  model: string,
  noMargin?: boolean
};

export default class ErrorMessage extends Component<Props> {
  render() {
    return (
      <ErrorMessageDiv>
        <WarningSVG styled={{ noMargin: this.props.noMargin }} />
        <WarningTextH5>Failed to Load {this.props.model}</WarningTextH5>
      </ErrorMessageDiv>
    );
  }
}
